'use strict';

angular.module('TurneroApp').component('coReportesEncuestas', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        'utilsService',
        'reportesService',
        'TurneroAppConstant',
        '$sce',
        'centrosAtencionService',
        function (utilsService, reportesService, TurneroAppConstant, $sce, centrosAtencionService) {
            var ctrl = this;
            Chart.defaults.global.colors[1] = '#40da68';

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.tiposRespuesta = TurneroAppConstant.TiposRespuesta;
            ctrl.colores = Chart.defaults.global.colors;
            ctrl.Fecha_Desde_Maximo = ctrl.Fecha_Hasta_Maximo = new Date();

            ctrl.limpiarMemoria = function () {
                ctrl.Reportes = {
                    EncuestaReporte: null,
                }
                ctrl.loading = {
                    EncuestaReporte: false,
                }
            };

            ctrl.$onInit = function () {
                ctrl.Reportes = null;
                ctrl.Filtro = {
                    FechaDesde: moment().startOf('day'),
                    FechaHasta: moment().endOf('day'),
                    centroSeleccionado: undefined,
                    soloCentrosActivos: 'N'
                };

                ctrl.filtrarCentros();
                ctrl.filtrarAgendas();
                ctrl.filtrarTramites();
            }
            
            ctrl.cambiarFechaDesde = function (fecha) {
                if (fecha) {
                    // La fecha hasta MINIMA es la seleccionada en la fecha desde
                    var momentHastaMinimo = moment(fecha);
                    ctrl.Fecha_Hasta_Minimo = momentHastaMinimo.toDate();
                }
            }

            ctrl.cambiarFechaHasta = function (fecha) {
                if (fecha) {
                    // La fecha desde MAXIMA es la seleccionada en la fecha hasta
                    var momentDesdeMaximo = moment(fecha);
                    ctrl.Fecha_Desde_Maximo = momentDesdeMaximo.toDate();
                }
            }
            
            ctrl.generarReportes = function () {

                var limpiarValorCentroAtencionAlFinalizar = false;
                utilsService.swalTitle('Generando estadísticas', 'info');

                ctrl.Reportes = null;

                if (!ctrl.Filtro.centroSeleccionado) {
                    ctrl.Filtro.centroSeleccionado = ctrl.centroAtencionSeleccionado;
                    limpiarValorCentroAtencionAlFinalizar = true;
                }

                if (!ctrl.Filtro.FechaDesde || !ctrl.Filtro.FechaHasta || !moment(ctrl.Filtro.FechaDesde).isValid() || !moment(ctrl.Filtro.FechaHasta).isValid()) {
                    sweetAlert("Campos incompletos", 'Es necesario completar la fecha desde y la fecha hasta, para generar el reporte.', "warning");
                    return
                }

                ctrl.limpiarMemoria();
                var filtro = {
                    Id_Centro_Atencion: ctrl.Filtro.centroSeleccionado.id,
                    //Se necesita convertir a moment dado que al editarse la fecha, el componente mdDatepicker escribe un JS Date aunque haya sido inicializado con objetos moment
                    //Enviamos en formato simil JSON/ISO8601 para que sea parseado en el backend con cualquier configuración regional y con la hora Desde/Hasta local al server
                    FecDesde: ctrl.Filtro.FechaDesde ? moment(ctrl.Filtro.FechaDesde).format('YYYY-MM-DDT00:00:00') : moment().format('YYYY-MM-DDT00:00:00'),
                    FecHasta: ctrl.Filtro.FechaHasta ? moment(ctrl.Filtro.FechaHasta).format('YYYY-MM-DDT23:59:59') : moment().format('YYYY-MM-DDT23:59:59'),
                    Id_Agenda: ctrl.agendaSeleccionada,
                    Id_Tramite_Relevado: ctrl.tramiteSeleccionado
                }

                ctrl.Reportes_Encuestas(filtro);

                if (limpiarValorCentroAtencionAlFinalizar) {
                    ctrl.Filtro.centroSeleccionado = undefined;
                    ctrl.Filtro.soloCentrosActivos = 'N';
                }
            };

            ctrl.Reportes_Encuestas = function (filtro) {
                ctrl.loading.EncuestaReporte = true;
                reportesService.Reportes_Encuestas({ 'FecDesde': filtro.FecDesde, 'FecHasta': filtro.FecHasta, 'Id_Centro_Atencion': filtro.Id_Centro_Atencion, 'Id_Agenda': filtro.Id_Agenda, 'Id_Tramite_Relevado': filtro.Id_Tramite_Relevado }).$promise.then(function (resultado) {
                    ctrl.loading.EncuestaReporte = false;

                    if (resultado.Data.length > 0) {
                        ctrl.Reportes.EncuestaReporte = resultado.Data;

                        for (let i in ctrl.Reportes.EncuestaReporte) {
                            let pregunta = ctrl.Reportes.EncuestaReporte[i];

                            if (pregunta.Id_Tipo_Respuesta == ctrl.tiposRespuesta.Opciones ||
                                pregunta.Id_Tipo_Respuesta == ctrl.tiposRespuesta.SiNo) {
                                pregunta.data = [];
                                pregunta.labels = [];

                                for (let j in pregunta.Detalle) {
                                    pregunta.data.push(pregunta.Detalle[j].Respuestas_Por_Opcion);
                                    pregunta.labels.push(pregunta.Detalle[j].Descripcion);
                                }
                            }
                        }

                        swal.close();
                    } else {
                        sweetAlert("Sin resultados", 'No se han encontrado resultados para mostrar, con las fechas solicitadas.', "warning");
                    }
                }).catch(function (error) {
                    swal.close();
                    utilsService.errores(error);
                    ctrl.loading.EncuestaReporte = false;
                });
            }

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';

            ctrl.exportar = function (array, id_reporte) {
                var limpiarValorCentroAtencionAlFinalizar = false;
                utilsService.swalTitle('Exportando datos', 'info');

                if (!ctrl.Filtro.centroSeleccionado) {
                    ctrl.Filtro.centroSeleccionado = ctrl.centroAtencionSeleccionado;
                    limpiarValorCentroAtencionAlFinalizar = true;
                }

                var arrayObject = array;
                ctrl.arrayExport = [];
                ctrl.arrayExport[0] = ['Centro de Atención', ctrl.Filtro.centroSeleccionado.id + ' - ' + ctrl.Filtro.centroSeleccionado.text];
                //if (id_reporte == 1) {
                ctrl.arrayExport[1] = ['Fecha	', 'Turnos / % del total'];
                for (var i = 0; i < arrayObject.length; i++) {
                    ctrl.arrayExport[i + 2] = [
                        moment(arrayObject[i].Fecha).toDate().toLocaleDateString(),
                        (arrayObject[i].Cantidad + ' / ' + arrayObject[i].Porcentaje)
                    ]
                }

                ctrl.ExcelTurnosDia.down([{
                    name: 'Agendas',
                    data: ctrl.arrayExport
                }]);

                if (limpiarValorCentroAtencionAlFinalizar) {
                    ctrl.Filtro.centroSeleccionado = undefined;
                    ctrl.Filtro.soloCentrosActivos = 'N';
                }
                swal.close();
            }

            ctrl.ExcelTurnosDia = {
                down: function () {
                },
            }
            
            ctrl.filtrarCentros = function () {
                ctrl.borrarComboCentros();
                ctrl.promise = centrosAtencionService.Get_Combo_Centros_Atencion_x_Usuario({ 'Solo_Centros_Activos': ctrl.Filtro.soloCentrosActivos }).$promise.then(function (data) {
                    ctrl.centros = data.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.borrarComboCentros = function () {
                ctrl.Filtro.centroSeleccionado = undefined;

                ctrl.cambiarCentroSeleccionado();
            };

            ctrl.cambiarCentroSeleccionado = function () {
                ctrl.filtrarAgendas();
                ctrl.filtrarTramites();
            };

            ctrl.filtrarAgendas = function () {
                reportesService.getComboAgendas({
                    'id_centro_atencion': (!ctrl.Filtro.centroSeleccionado ? ctrl.centroAtencionSeleccionado.id : ctrl.Filtro.centroSeleccionado.id),
                    'id_tramite': ctrl.tramiteSeleccionado
                }).$promise.then(function (data) {
                    ctrl.agendas = data.Data;
                    ctrl.agendas.unshift({ id: null, text: 'TODAS' });
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.borrarComboAgendas = function () {
                ctrl.agendaSeleccionada = undefined;

                if (ctrl.tramiteSeleccionado == undefined)
                    ctrl.filtrarTramites();
            }

            ctrl.filtrarTramites = function () {
                reportesService.getComboTramites({
                    'id_centro_atencion': (!ctrl.Filtro.centroSeleccionado ? ctrl.centroAtencionSeleccionado.id : ctrl.Filtro.centroSeleccionado.id),
                    'id_agenda': ctrl.agendaSeleccionada
                }).$promise.then(function (data) {
                    ctrl.tramites = data.Data;
                    ctrl.tramites.unshift({ id: null, text: 'TODOS' });
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.borrarComboTramites = function () {
                ctrl.tramiteSeleccionado = undefined;

                if (ctrl.agendaSeleccionada == undefined)
                    ctrl.filtrarAgendas();
            }
        }],
    template: require('./reportesEncuestas.html')
});



// WEBPACK FOOTER //
// ./app/components/reportes/reportesEncuestasComponent.js